import { useNavigation } from "@react-navigation/native";
import Constants from "expo-constants";
import React, { useEffect, useState } from "react";
import { Linking, Text, View, Image } from "react-native";
import useStyles from "./styles.css";
import { tabletSize } from "@src/utils/screensize-helper";
import images from "@assets/images";

const CopyRightContent = () => {
  const styles = useStyles();
  const navigation = useNavigation<any>();
  const [ currentYear , setCurrentYear ] = useState("");
  const isTabletSize = tabletSize();

  useEffect (() => {
    const year = new Date().getFullYear();
    setCurrentYear(
      year + ""
    );
  }, []);
  

  return (
    <View style={[styles.drawer_content_footer, { justifyContent: 'flex-end' }]}>
      {!isTabletSize ? 
        <>
        <Image tintColor={'white'} style={{ marginBottom: 3, width:100 , height: 25, left: "12%"}} source={images.LogoUnawa} resizeMode="contain"/>
        <Text style={styles.copyRightStyle}>
          <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("terms-condition")}>Terms & Conditions</Text> |
          <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("privacy-policy")}> Privacy Policy</Text>
          {"\n"}
          © { currentYear + " " }
          <Text style={styles.copyRightBtnStyle} onPress={() => Linking.openURL("https://www.unawa.asia")}>
            UNAWA
          </Text>. All rights reserved
          { "\n"}
           Ver. 2.1.4
        </Text>
        </>
       :
       <Text style={[styles.copyRightStyle, { left: 0, alignSelf: 'flex-end', textAlign: 'right', paddingRight: 30, }]}>
            <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("terms-condition")}>Terms & Conditions</Text> {"\n"}
            <Text style={styles.copyRightBtnStyle} onPress={() => navigation.navigate("privacy-policy")}>Privacy Policy</Text>
            {"\n"}
  
            {"\n"}© 2025 SignSecure {"\n"} All rights reserved
            </Text>
        }
    </View>
  );
};

export default CopyRightContent;
